var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damaged-items view" }, [
    _c(
      "div",
      { staticClass: "view_top" },
      [
        _c("ma-navbar-category", {
          attrs: {
            titleNavbar: _vm.titleNavBar,
            handleClickBack: _vm.handleOnClickPrevRoute,
            qaName: "go-to-damageTypesView-btn",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", [
          _vm._v(
            _vm._s(
              _vm.dataDamagedItems && _vm.dataDamagedItems.self_care_literal
                ? _vm.dataDamagedItems.self_care_literal
                : _vm.$t("damagedItems.defaultTitle")
            )
          ),
        ]),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.dataDamagedItems && _vm.dataDamagedItems.self_care_subtitle
                ? _vm.dataDamagedItems.self_care_subtitle
                : _vm.$t("damagedItems.defaultText")
            )
          ),
        ]),
        _c(
          "ul",
          {
            key: _vm.listKey,
            staticClass: "view-list has-two-cols",
            attrs: { "qa-list-damaged-items": "" },
          },
          _vm._l(_vm.dataDamagedItems.options, function (damagedItem) {
            return _c(
              "li",
              [
                _c("ma-damaged-item-btn", {
                  attrs: {
                    iconName: damagedItem.self_care_icon,
                    buttonTitle: damagedItem.literal,
                    valueInput: damagedItem.key,
                    type: _vm.retrieveButtonType(damagedItem.self_care_icon),
                    quantitySelected:
                      _vm.dataDamagedItemsSelected[damagedItem.key] || 0,
                  },
                  on: {
                    "button:clicked": function ($event) {
                      return _vm.handleClickDamagedItem(
                        damagedItem.key,
                        damagedItem.literal
                      )
                    },
                    "button:quantityChanged": function ($event) {
                      return _vm.handleOnQuantityChange(damagedItem.key, $event)
                    },
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _vm.isMultidamage
          ? _c("maButtonNext", {
              attrs: {
                handleButtonClick: _vm.handleOnContinue,
                title: _vm.$t("damagedItems.buttonTitle"),
                btnType: "functionalBtn",
                shouldBeDisabled: _vm.isContinueDisabled,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }